import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/components/Footer.css';

const Footer = () => {
  const handleContactClick = () => {
    window.location.href = "mailto:yourname@example.com";
  };
  return (
    <footer className="footer">
      <div className="footer-bg-gradient"></div>
      
      <div className="container footer-container">
        <div className="footer-top">
          <div className="footer-logo-section">
            <div className="footer-logo">
            <span className="logo-text">
                <span style={{ color: 'var(--dark-text-primary)' }}>Smart</span>
                 <span style={{ 
                     background: 'linear-gradient(135deg, var(--primary) 50%, var(--secondary) 100%)', 
                     WebkitBackgroundClip: 'text', 
                      }}>
                GPT
               </span>
               <span style={{ color: 'var(--dark-text-primary)' }}>{" TAG"}</span>
              </span>
            </div>
            <div className="footer-tagline">
              Unleash your productivity and get more done with SmartGPT Tag Assistant.
            </div>
           
          </div>
        </div>
        
        <div className="footer-columns">
          <div className="footer-column">
            <h3 className="footer-column-title">Product</h3>
            <ul className="footer-links">
              <li className="footer-link"><Link to="/pricing">Plans & Pricing</Link></li>
            
              
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-column-title">Support</h3>
            <ul className="footer-links">
           
            <li > <p>Email: pixelinnovators.21@gmail.com</p></li>
            <li > <p>Phone: +91 8248350313</p></li>
          </ul>


           

          </div>
          
        
          
          <div className="footer-column">
            <h3 className="footer-column-title">Legal</h3>
            <ul className="footer-links">
           
             
              <li className="footer-link"><Link to="/privacy_policy">Privacy Policy</Link></li>
              <li className="footer-link"><Link to="/terms_and_conditions">Terms & Conditions </Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} SmartGPT Tag Assistant. All rights reserved.</p>
          </div>
          <div className="footer-made-with">
            <p>Made with <span className="heart">❤</span> for productivity</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;